// extracted by mini-css-extract-plugin
export default {"toolbar":"BjQSF","inner":"NBRMz","title":"bHypg","textWrapper":"VlFp4","text":"iNIKe","dropdownIcon":"IeLNA","dropdownIconOpen":"tZucx"};